import { useSyncExternalStore } from 'react';

/**
 * A small screen: a phone either way up (narrow, or short when held on its side), or a tablet
 * held upright. Panels fold away and windows take the whole screen there (mobile.css has the
 * same breakpoints).
 */
export const COMPACT_QUERY = '(max-width: 900px), (max-height: 520px)';

const query = typeof matchMedia === 'function' ? matchMedia(COMPACT_QUERY) : null;

function subscribe(onChange: () => void): () => void {
  query?.addEventListener('change', onChange);
  return () => query?.removeEventListener('change', onChange);
}

/** Whether the screen is a small one (COMPACT_QUERY), following rotation and resizing. */
export function useCompact(): boolean {
  return useSyncExternalStore(subscribe, () => query?.matches ?? false);
}

/** The same, once (for initial state). */
export function isCompact(): boolean {
  return query?.matches ?? false;
}
